import { useEffect, useState } from 'react';
import api from '../api/client';

export const PLACEHOLDER = '[TO BE PROVIDED]';

let cached = null;
let pending = null;

const load = () => {
  if (cached) return Promise.resolve(cached);
  if (!pending) {
    pending = api
      .get('/api/site/config/')
      .then((res) => (cached = res.data))
      .catch(() => ({}))
      .finally(() => {
        pending = null;
      });
  }
  return pending;
};

// Operator name/CIN, contact details etc. come from backend settings, never from the UI.
export default function useSiteConfig() {
  const [config, setConfig] = useState(cached || {});
  useEffect(() => {
    let live = true;
    load().then((c) => live && setConfig(c));
    return () => {
      live = false;
    };
  }, []);
  return config;
}
